// AUTO-GENERATED from services/app-api-service/codeigniter/application/contracts/ContasRecebimentos_DeleteInput.php
// Do not edit by hand — edit the PHP InputContract and the sync hook will regenerate this file.
// Bulk regeneration: scripts/sync-contracts/sync-all.sh

/**
 * InputContract for /contas/recebimentos/delete
 *
 * Deletes an account receivable by ID.
 */
import { registerContract } from './validate'

export interface ContasRecebimentos_DeleteInput {
recebimento_id: number
}

registerContract('ContasRecebimentos_DeleteInput', {
  recebimento_id: { type: 'number',  required: true },
})
